import React, { Component } from 'react';
import './App.css';
import ReactRichEditor, { html } from 'react-richeditor-skeleton';
import Suggestion from './Suggestion';

class App extends Component {
  state = {
    show: true,
    htmlStr: ''
  };

  editorRef = React.createRef<ReactRichEditor>();

  serialize = () => {
    const htmlStr = this.editorRef.current!.getHtml();
    this.setState({ htmlStr });
  };

  deserialize = () => {
    this.setState({ show: false }, () => {
      setTimeout(() => {
        this.setState({ show: true });
      }, 100);
    });
  };

  render() {
    const { show, htmlStr } = this.state;

    return (
      <div
        className={'container'}
        style={{ display: 'flex', flexDirection: 'row' }}
      >
        {show && (
          <ReactRichEditor
            initialHtml={htmlStr}
            className="richeditor"
            ref={this.editorRef}
            style={{ width: 500, height: 500, padding: '6px 12px' }}
          >
            {{
              suggestionNode: (keywords, onSelect) => (
                <Suggestion keywords={keywords} onSelect={onSelect} />
              )
            }}
          </ReactRichEditor>
        )}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <input
              type="button"
              onClick={this.serialize}
              value={'左侧文档->>右侧html'}
            />
            <input
              type="button"
              onClick={this.deserialize}
              value={'右侧html<<-左侧文档'}
            />
          </div>
          <div>
            <textarea
              style={{ width: 400, height: 300 }}
              value={htmlStr}
              onChange={e => {
                this.setState({ htmlStr: e.target.value });
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default App;
